import React from "react";
import "./style.scss";

export const DotLoader = () => {
  return (
    <div className="dot_loader_container">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  );
};
